<script>
import {useEvaluationFileModelStore} from "@/stores/Evaluation/EvaluationFileModel.js"
import useSharedData from "@/use/SharedData.js";
import useTools from "@/use/Tools.js";
import {computed, onMounted, ref} from "vue";
import {useSecurityStore} from "@/stores/Security.js";
import axios from "axios";

export default {
    props: {
        type: String,
    },
    setup(props) {
        const {total, loading} = useSharedData();

        const {$i18n, $router} = useTools();

        const search = ref(null);

        const evaluationFileModelStore = useEvaluationFileModelStore();
        const securityStore = useSecurityStore();

        const rootPath = computed(() => {
            if (props.type === 'EVALUATION_SKILL') {
                return 'evaluation_skill_file_models';
            } else if (props.type === 'EVALUATION_PERFORMANCE') {
                return 'evaluation_performance_file_models';
            }
        });

        const headers = [
            {
                text: "...",
                align: "left",
                sortable: false,
                value: "action",
                width: "0%"
            },
            {
                text: $i18n.t("common.label"),
                align: "left",
                sortable: true,
                value: "name",
                width: "0%",
            },
            {
                text: $i18n.t("evaluation.cycle"),
                align: "left",
                sortable: true,
                value: "cycle",
                width: "0%"
            },
            {
                text: $i18n.t("common.concerned"),
                align: "left",
                sortable: false,
                value: "occupationNames",
            },
        ];

        const actions = [
            {
                title: $i18n.t("common.edit"),
                icon: 'mdi-pencil-box-multiple',
                color: 'orange',
                access: () => securityStore.authorities['UPDATE_EVALUATION_PARAM'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: `${rootPath.value}.edit`, params: {id: item.id}})
                },
            },
            {
                title: $i18n.t("common.delete"),
                icon: 'mdi-trash-can',
                color: 'red',
                access: () => securityStore.authorities['UPDATE_EVALUATION_PARAM'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: `${rootPath.value}.delete`, params: {id: item.id}})
                },
            },
        ];

        function findAll() {
            loading.value = true;
            axios.get('/evaluationFileModels', {
                params: {
                    type: props.type,
                }
            }).then((response) => {
                evaluationFileModelStore.setEvaluationFileModels(response.data);
                total.value = response.data.length;
            }).finally(() => {
                loading.value = false;
            });
        }

        function view(item) {
            $router.push({name: `${rootPath.value}.view`, params: {id: item.id}});
        }

        onMounted(() => findAll());

        return {
            evaluationFileModelStore,
            rootPath,
            securityStore,
            headers,
            actions,
            total,
            loading,
            search,
            view,
            findAll,
        };
    },
};
</script>

<template>
    <div>
        <w-app
            :title="$t(`module.${rootPath}`)"
            :total="total"
        >
            <template v-slot:rightToolbar>
                <w-btn-reload
                    :loading="loading"
                    @press="findAll"
                />
                <w-btn-add
                    :show="securityStore.authorities['UPDATE_EVALUATION_PARAM']"
                    @press="$router.push({ name: `${rootPath}.add` })"
                />
            </template>

            <template v-slot:content>
                <v-container fluid>
                    <v-row dense>
                        <v-col cols="3">
                            <w-text-field
                                v-model="search"
                                :label="$t('common.search')"
                            />
                        </v-col>
                    </v-row>
                </v-container>
                <w-data-table
                    :headers="headers"
                    :actions="actions"
                    :search="search"
                    :items="evaluationFileModelStore.evaluationFileModels"
                    :total="total"
                    :loading="loading"
                    sort-by="name"
                    @rowDbClick="view"
                >

                    <template v-slot:[`item.name`]="{ item }">
                        <w-inline-text bold :text="item.name"/>
                    </template>
                    <template v-slot:[`item.cycle`]="{ item }">
                        <w-inline-text :text="$t(`evaluation.${item.cycle}`)"/>
                    </template>
                    <template v-slot:[`item.occupationNames`]="{ item }">
                        <w-chip-list :strings="item.occupationNames"/>
                    </template>
                    <template v-slot:[`item.stepNames`]="{ item }">
                        <w-chip-list :strings="item.stepNames"/>
                    </template>
                </w-data-table>
            </template>
        </w-app>
        <router-view/>
    </div>
</template>
